import { Type } from "@sinclair/typebox";

//#region src/shared/bricks/props/position.ts
function fixedPositioned(defaultValue = false, title = "Fixed position") {
	return Type.Boolean({
		title,
		default: defaultValue,
		"ui:styleId": "styles:fixedPositioned"
	});
}

//#endregion
export { fixedPositioned };
//# sourceMappingURL=position.js.map